import { addDays, formatDate, momentDate } from 'util/dateTime';

export const toMonthDayOrdinal = date =>
  formatDate(new Date(date), 'month_day_ordinal');

export const deadlineToDate = (date, gracePeriod = 0) =>
  addDays(momentDate(date, 'MM-DD-YYYY'), gracePeriod);
